import { useEffect, useMemo } from 'react'
import useValidations from 'hooks/useValidations'
import { useNotificationContext } from 'units/notifications/NotificationContext'
import { messageOf, messages } from '../Message'
import { refusalOf, wordingOf } from '../forms/refusal'

const LOAD_FAILURES = {
    addresses: 'CONTACT_ADDRESSES_LOAD_FAILED',
    details: 'CONTACT_DETAILS_LOAD_FAILED',
}

export default function useContactPageValidations(loadValidations, { labelOf } = {}) {
    const { addNotification } = useNotificationContext()
    const { showValidations, scrollToNotices } = useValidations()

    const locked = useMemo(() => {
        const codes = (loadValidations ?? []).map((validation) => validation.code)

        return {
            addresses: codes.includes(LOAD_FAILURES.addresses),
            details: codes.includes(LOAD_FAILURES.details),
        }
    }, [loadValidations])

    useEffect(() => {
        if (loadValidations == null) {
            return
        }

        showValidations(loadValidations)

        if (loadValidations.length > 0) {
            const content = loadValidations
                .map((validation) => messages[validation.code] ?? validation.code)
                .join(' ')

            addNotification({
                type: 'error',
                content,
            })
        }
    }, [loadValidations])

    const showSaved = () => {
        showValidations(loadValidations ?? [])
    }

    const showRefusal = (error, overrides = {}) => {
        const { notices, fieldErrors } = refusalOf(error, { labelOf: overrides.labelOf ?? labelOf })
        const hasPathErrors = (error?.response?.data?.error?.details?.errors ?? []).length > 0
        const content = hasPathErrors
            ? notices.map((notice) => wordingOf(notice.code, notice.params)).join(' ')
            : messageOf(error)

        addNotification({
            type: 'error',
            content,
        })

        showValidations([...(loadValidations ?? []), ...notices])
        scrollToNotices()

        return fieldErrors
    }

    return {
        locked,
        showSaved,
        showRefusal,
    }
}
